/** @jsx jsx */
import React, { useState, Fragment, useEffect, useRef } from 'react'
import { css, jsx } from '@emotion/core'
import { observer } from 'mobx-react'
// css
import { ListView } from 'antd-mobile'
import { FavoriteUserListWrap } from '@views/MyPage/index.style'
import _ from 'lodash'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON, GIFT_BTN_TYPE } from '@constants/index'
import BettorGiftContentPopup from '@views/Popup/BettorGiftContentPopup'
import MessageContentPopup from '@views/Popup/MessageContentPopup'
import { FAVORITE_USER_SORT, FROM_VIEW_TYPE, FAVORITE_USER_SAVE_MODE } from '@v2/constants/common'
import { List, Popover } from 'antd'
import { BettorWrap, BtnStyle, ButtonWrap } from '@views/BettorFind/index.style'
import { Button, QuickSpotsMenuBtnStyle } from '@styles/button.style'
import AdvImg from '@components/AdvImg'
import { UserPickSpecialMemberMark } from '@views/Home/UserPick/Components/UserPickSpecialMemberMark'
import { SendbetCouponIco, SendHeartIco, SendMessageIco } from '@shared/Icon/EtcIcon'
import PopupUtils from '@utils/popup-utils'
import { bettingHistoryStore } from '@store/index'
import useRootStore from '@store/useRootStore'
import FilterArrowIco from '../../../../shared/Icon/EtcIcon/FilterArrowIco'
import { SpotsQuickMenuList } from '@styles/modal'
import FavoriteImg from '@assets/images/icon/etc_icon/favorite-ico.png'
import MessageImg from '@assets/images/icon/chat_icon/message-ico.png'
import { FavoriteUsersButton } from '@components/Button/FavoriteUsersButton'
import DialogUtils from '@utils/dialog-utils'
import { Schema$Bettor } from '@protocol/bettor'
import { useOnUnmount } from '@utils/reactExt'
import { formatCreatedAtToElapsedTime, showToast, TOAST_TYPE } from '@utils/utils'

const FAVORITE_ACTIVE_CLASS = 'icon-btn active ani'

const ListViewStyle = css`
    background: #ddd;
    height: 100%;
`

export const FavoriteUserList: React.FC = observer(() => {
  const { bettorStore, componentStore, userStore } = useRootStore()
  const [visibleMessageSend, setVisibleMessageSend] = useState(false)
  const [visibleHeartSend, setVisibleHeartSend] = useState(false)
  const [customProfile, setCustomProfile] = useState(false)
  const [nick, setNick] = useState('')
  const [profile, setProfile] = useState('')
  const [receiveId, setReceiveId] = useState('')
  const [sort, setSort] = useState(FAVORITE_USER_SORT.CREATED_AT)
  const [sortPopoverVisible, setSortPopoverVisible] = useState(false)
  const [favoriteUserPopoverVisible, setFavoriteUserPopoverVisible] = useState(false)
  const { favoriteUsers = [], favoriteUsersHasMore, favoriteUsersTotalCount, favoriteUserSaveMode } = userStore

  const favoriteUserSaveModeRef = useRef(favoriteUserSaveMode)

  const isTicketSendable = userStore.checkTicketSendable()
  const isHeartSendable = userStore.checkHeartSendable()

  const receive = {
    id: receiveId,
    nick,
    profile,
    title: '',
  }

  const action = 'send'
  useOnUnmount(() => {
    const currentMode = favoriteUserSaveModeRef.current
    if (currentMode === FAVORITE_USER_SAVE_MODE.NONE
      || currentMode === FAVORITE_USER_SAVE_MODE.REGISTER_ALL) {
      userStore.addAllFavoriteUsers().catch(console.error)
    } else if (currentMode === FAVORITE_USER_SAVE_MODE.UNREGISTER_ALL) {
      userStore.removeAllFavoriteUsers().catch(console.error)
    }
  })
  useEffect(() => {
    userStore.fetchFavoriteUsers({ sort, reset: true }).catch(console.error)
  }, [sort])

  useEffect(() => {
    favoriteUserSaveModeRef.current = favoriteUserSaveMode
  }, [favoriteUserSaveMode])
  const onCommonSendComponent = (
    inputNick: string, inputCustomProfile: boolean, inputProfile: string,
  ): void => {
    setNick(inputNick)
    setCustomProfile(inputCustomProfile)
    setProfile(inputProfile)
    setVisibleHeartSend(true)
  }

  const onShowHeartSendComponent = (
    inputNick: string, inputCustomProfile: boolean, inputProfile: string,
  ): void => {
    bettorStore.setGiftBtnType(GIFT_BTN_TYPE.HEART)
    onCommonSendComponent(inputNick, inputCustomProfile, inputProfile)
  }

  const onShowTicketSendComponent = (
    inputNick: string, inputCustomProfile: boolean, inputProfile: string,
  ): void => {
    bettorStore.setGiftBtnType(GIFT_BTN_TYPE.TICKET)
    onCommonSendComponent(inputNick, inputCustomProfile, inputProfile)
  }

  const onShowMessageSendComponent = (
    inputNick: string, inputCustomProfile: boolean,
    inputProfile: string, inputReceiveId: string,
  ) => {
    setNick(inputNick)
    setCustomProfile(inputCustomProfile)
    setProfile(inputProfile)
    setReceiveId(inputReceiveId)
    componentStore.setExtraClubId(null)
    bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.BETTOR_FIND)
    bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: false, fromViewType: FROM_VIEW_TYPE.BETTOR_FIND })
    setVisibleMessageSend(true)
  }

  const onClickUserDetailInfoPopup = (item: Schema$Bettor): void => {
    PopupUtils.showUserDetailInfo(item.id)
  }
  const onClickSendMessageButton = (item: Schema$Bettor): void => {
    onShowMessageSendComponent(item.nick, item.custom_profile_img, item.profile_img_url, item.id)
  }
  const onClickTicketButton = (item: Schema$Bettor): void => {
    onShowTicketSendComponent(item.nick, item.custom_profile_img, item.profile_img_url)
  }
  const onClickHeartButton = (item: Schema$Bettor): void => {
    onShowHeartSendComponent(item.nick, item.custom_profile_img, item.profile_img_url)
  }

  const dataSource = new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  })

  const handleSortSelect = (value) => {
    setSortPopoverVisible(false)
    setSort(value)
  }

  const setRegistgerFavoriteBettorActionMode = () => {
    userStore.setFavoriteUserSaveMode(FAVORITE_USER_SAVE_MODE.REGISTER_ALL)
    userStore.setAllUserFavorite(true)
  }

  const setUnRegistgerFavoriteBettorActionMode = () => {
    userStore.setFavoriteUserSaveMode(FAVORITE_USER_SAVE_MODE.UNREGISTER_ALL)
    userStore.setAllUserFavorite(false)
  }

  const handleSelectAllFavorites = () => {
    DialogUtils.showRegisterAllFavorites(setRegistgerFavoriteBettorActionMode)
  }

  const handleDeselectAllFavorites = () => {
    DialogUtils.showUnregisterAllFavorites(setUnRegistgerFavoriteBettorActionMode)
  }

  const favoriteUsersSortFilter = (
    <SpotsQuickMenuList className="message-quick-list favorite-user-setting">
      <ul className="quick-menu-list">
        <li className="quick-menu-list--item">
          <Button
            className="quick-btn"
            onClick={() => {
              handleSortSelect(FAVORITE_USER_SORT.CREATED_AT)
            }}
          >
            <img src={FavoriteImg} alt="" className="quick-btn--img"/>
            관심등록 순
          </Button>
        </li>
        <li className="quick-menu-list--item">
          <Button
            className="quick-btn"
            onClick={() => {
              handleSortSelect(FAVORITE_USER_SORT.LAST_MESSAGE_SENT_AT)
            }}
          >
            <img src={MessageImg} alt="" className="quick-btn--img"/>
            메시지 보낸 순
          </Button>
        </li>
      </ul>
    </SpotsQuickMenuList>
  )

  let sortTypeTxt: string = '관심등록순'
  if (sort === FAVORITE_USER_SORT.LAST_MESSAGE_SENT_AT) {
    sortTypeTxt = '메시지보낸순'
  }

  const favoriteUsersQuickMenu = (
    <SpotsQuickMenuList className="message-quick-list">
      <ul className="quick-menu-list">
        <li className="quick-menu-list--item">
          <Button
            className="quick-btn txt-center"
            onClick={() => {
              setFavoriteUserPopoverVisible(false)
              handleSelectAllFavorites()
            }}>
            전체등록
          </Button>
        </li>
        <li className="quick-menu-list--item">
          <Button
            className="quick-btn quick-btn--danger txt-center"
            onClick={() => {
              setFavoriteUserPopoverVisible(false)
              handleDeselectAllFavorites()
            }}>
            전체해제
          </Button>
        </li>
      </ul>
    </SpotsQuickMenuList>
  )

  const renderHeader = () => (
    <Fragment>
      <p className="favorite-users-count">총 {favoriteUsersTotalCount}명</p>
      <Popover
        onVisibleChange={setSortPopoverVisible}
        visible={sortPopoverVisible}
        placement="bottomRight"
        content={favoriteUsersSortFilter}
        trigger="click"
        overlayClassName="betting-history-quick-menu favorite-user-filter"
      >
        <Button TP className="favorite-users-sort-filter-btn">
          <FilterArrowIco/>
          {sortTypeTxt}
        </Button>
      </Popover>
      <Popover
        onVisibleChange={setFavoriteUserPopoverVisible}
        visible={favoriteUserPopoverVisible}
        placement="bottomRight"
        content={favoriteUsersQuickMenu}
        trigger="click"
        overlayClassName="betting-history-quick-menu favorite-user-setting"
      >
        <Button className="favorite-users-setting-btn" css={QuickSpotsMenuBtnStyle}>
          <span className="spots"/>
        </Button>
      </Popover>
    </Fragment>
  )

  const onClickFavoriteUser = (user: Schema$Bettor): void => {
    if (_.isEmpty(user)) {
      return
    }

    if (user.isFavoriteUser) {
      userStore.setUserFavorite({ userPromiseIds: [user.id], isFavorite: false })
      showToast(TOAST_TYPE.INFO, '관심 해제되었습니다.')
    } else {
      userStore.setUserFavorite({ userPromiseIds: [user.id], isFavorite: true })
      showToast(TOAST_TYPE.INFO, '관심 등록되었습니다.')
    }
  }

  const renderRow = (user: Schema$Bettor) => {
    const favoriteUsersButtonClass = `${user.isFavoriteUser ? FAVORITE_ACTIVE_CLASS : 'icon-btn'}`
    return (
      <List.Item>
        <BettorWrap>
          <FavoriteUsersButton
            className={favoriteUsersButtonClass}
            onClick={() => onClickFavoriteUser(user)}
          />
          <Button TP className="user-profile-btn" onClick={() => onClickUserDetailInfoPopup(user)}>
            <div className="profile-img-wrap">
              {user.custom_profile_img ?
                (<AdvImg src={user.profile_img_url} srcMode={'small'} alt="사진첩 프로필"
                         className="profile-img custom-img"/>)
                :
                (<AdvImg src={user.profile_img_url} srcMode={'small'} alt="스킨 프로필" className="profile-img"/>)
              }
            </div>
            <UserPickSpecialMemberMark
              showSMark={user.sMemberMark}
              isSpecialMember={!_.isNil(user.sMember)}
              userTitleId={user.userTitleId}
              userTitleEnabled={user.userTitleEnabled}
              tiny
              lightBorder/>
            {user.isOnline && <span className="online-status"/>}
          </Button>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className="bettor-name" dangerouslySetInnerHTML={{ __html: `${user.nick}` }}/>
          </div>
        </BettorWrap>
        <ButtonWrap>
          {isTicketSendable && (
            <Button TP onClick={() => onClickTicketButton(user)} css={BtnStyle} className="bet-coupon">
              <SendbetCouponIco/>
            </Button>
          )}
          {isHeartSendable && (
            <Button TP onClick={() => onClickHeartButton(user)} css={BtnStyle} className="heart">
              <SendHeartIco/>
            </Button>
          )}
          <Button TP onClick={() => onClickSendMessageButton(user)} css={BtnStyle} className="message">
            <SendMessageIco/>
            <span className="message--time-info">{formatCreatedAtToElapsedTime({
              createdAt: user.lastMessageSentAt,
              overDateText: '오래전',
            })}</span>
          </Button>
        </ButtonWrap>
      </List.Item>
    )
  }

  const renderFooter = () => {
    let footer
    if (_.isEmpty(favoriteUsers)) {
      footer = <AdvEmpty ico={EMPTY_ICON.FAVORITE_USERS_LIST}/>
    } else {
      footer = <Fragment/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const endReachedHandler = async () => {
    if (favoriteUsersHasMore) {
      await userStore.fetchFavoriteUsers({ sort: sort, reset: false })
    }
  }

  return (
    <FavoriteUserListWrap>
      <ListView
        className="favorite-users-list"
        dataSource={dataSource.cloneWithRows(favoriteUsers)}
        renderHeader={_.size(favoriteUsers) > 0 && renderHeader}
        renderRow={renderRow}
        renderFooter={renderFooter}
        onEndReached={endReachedHandler}
        scrollRenderAheadDistance={500}
        onEndReachedThreshold={10}
        pageSize={20}
        initialListSize={20}
        css={ListViewStyle}
      />
      <BettorGiftContentPopup
        visible={visibleHeartSend}
        setVisible={setVisibleHeartSend}
        nick={nick}
        isCustomProfile={customProfile}
        profile={profile}
      />
      <MessageContentPopup
        visible={visibleMessageSend}
        setVisible={setVisibleMessageSend}
        receive={receive}
        action={action}
        useRequestWaitTimer
        fromViewType={FROM_VIEW_TYPE.BETTOR_FIND}
      />
    </FavoriteUserListWrap>
  )
})
